<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <div id="coral-home"></div>
    <div v-show="!instructionsActive" class="home-container">
      <h1 class="title">Fishy Problems!</h1>
      <h3 class="subtitle">Written Problems About Time</h3>
      <button @click="clickInstructions">Instructions</button>
    </div>
    <div v-show="instructionsActive" class="instructions-container">
      <h3 class="instructions">
        Read the problem and choose the fish that has the correct answer and then click submit.
      </h3>
      <h3>Good luck!</h3>
      <button @click="clickStart">Start</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  data: () => ({
    instructionsActive: false,
  }),
  computed: {
    ...mapGetters({
      homeScreenStatus: 'fishyProblems/homeScreenStatus',
    }),
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('coral-home'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `/assets/practices/fishy_problems/animations/coral.json`,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });
  },
  methods: {
    ...mapActions({
      homeClickStart: 'fishyProblems/homeClickStart',
    }),
    clickInstructions() {
      sounds.globalButton.play();
      this.instructionsActive = !this.instructionsActive;
    },
    clickStart() {
      sounds.globalButton.play();
      this.homeClickStart();
      this.instructionsActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;
  background: #b9a7ff;
  background: linear-gradient(180deg, #b9a7ff 0%, #6b94f2 50%, #065bdb 100%);
  height: 100vh;
  position: absolute;
  width: 100vw;

  #coral-home {
    height: 100%;
    width: 100%;
    position: absolute;
  }

  .home-container,
  .instructions-container {
    @include flex-center;
    flex-direction: column;
    text-align: center;
    width: 80vw;
    z-index: 1;

    * {
      margin: 0.25em;
    }

    .title {
      color: $fishy-problems-color-text-title;
    }

    button {
      @include button(#e9004f, #fff);
      margin-top: 2em;
    }
  }

  .instructions-container {
    .instructions {
      line-height: 1.5;
    }
  }
}
</style>
